import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from './LanguageContext';
const videos = ['https://cdn.magicpatterns.com/uploads/rqBsNsn4ndahSj6yYCmvUp/lifting su proceso.mov', 'https://cdn.magicpatterns.com/uploads/dNg62bXXMBLrWgG4aXjkzf/Grabación de pantalla 2026-05-03 a la(s) 18.10.46.mov', 'https://cdn.magicpatterns.com/uploads/qx8qbK4oF5bsqwwT6guva8/cada diseño es personalizado.mov', 'https://cdn.magicpatterns.com/uploads/qCJqFQxG3KgUGC3gqQ72gW/Grabación de pantalla 2026-05-03 a la(s) 18.11.53.mov'];
function VideoPlayer({
  src
}: {
  src: string;
}) {
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);
  const togglePlay = () => {
    if (videoRef.current) {
      if (videoRef.current.paused) {
        videoRef.current.play();
        setIsPlaying(true);
      } else {
        videoRef.current.pause();
        setIsPlaying(false);
      }
    }
  };
  return <div className="relative w-full h-full cursor-pointer group bg-black/5" onClick={togglePlay} data-id="element-205">
      <video ref={videoRef} src={src} className="w-full h-full object-cover" loop muted playsInline preload="auto" onPlay={() => setIsPlaying(true)} onPause={() => setIsPlaying(false)} data-id="element-206" />
      {!isPlaying && <div className="absolute inset-0 bg-black/20 flex items-center justify-center transition-all duration-300 group-hover:bg-black/30" data-id="element-207">
          <div className="w-14 h-14 bg-white/80 backdrop-blur-sm rounded-full flex items-center justify-center shadow-lg transform group-hover:scale-110 transition-transform" data-id="element-208">
            <svg className="w-6 h-6 text-[#2C1810] ml-1" fill="currentColor" viewBox="0 0 24 24" data-id="element-209">
              <path d="M8 5v14l11-7z" data-id="element-210" />
            </svg>
          </div>
        </div>}
    </div>;
}
export function ProcessSection() {
  const {
    t
  } = useLanguage();
  return <section className="w-full py-24 bg-[var(--warm-cream)]" data-id="element-211">
      <div className="max-w-7xl mx-auto px-0 md:px-12" data-id="element-212">
        <div className="text-center mb-12 px-6" data-id="element-213">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="flex flex-col items-center" data-id="element-214">
            <div className="flex items-center gap-4 mb-4" data-id="element-215">
              <div className="w-8 h-[1px] bg-[#D4AF37]" data-id="element-216"></div>
              <h2 className="font-serif text-sm tracking-[0.3em] uppercase text-[#C9956A]" data-id="element-217">
                {t('process_label')}
              </h2>
              <div className="w-8 h-[1px] bg-[#D4AF37]" data-id="element-218"></div>
            </div>
            <h3 className="font-serif text-4xl md:text-5xl text-[#2C1810]" data-id="element-219">
              {t('process_title')}
            </h3>
          </motion.div>
        </div>

        {/* Native Scroll Snap Carousel */}
        <div className="flex overflow-x-auto snap-x snap-mandatory gap-6 px-6 md:px-0 pb-8 pt-4 [&::-webkit-scrollbar]:hidden" style={{
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
      }} data-id="element-220">
          {videos.map((src, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="snap-center shrink-0 w-[75vw] max-w-xs aspect-[3/4] relative rounded-2xl overflow-hidden shadow-lg border border-[#D4AF37]/20" data-id="element-221">
              <VideoPlayer src={src} data-id="element-222" />
            </motion.div>)}
        </div>

        <div className="text-center mt-2 text-[#C9956A] text-sm font-light flex items-center justify-center gap-2" data-id="element-223">
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-224">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" data-id="element-225" />
          </svg>
          <span data-id="element-226">{t('process_swipe')}</span>
        </div>
      </div>
    </section>;
}